import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: ' Smart Logistics Center (Trung tâm Logistics Thông minh) có sự khác biệt lớn so với ngành logistics truyền thống về mặt hiệu quả và năng suất. Do khả năng quản lý hiệu quả tài sản, hàng tồn kho và nhân lực để tối đa hóa năng suất và giảm thiểu sai sót, việc xây dựng Smart Logistics Center đã trở thành yếu tố thiết yếu cho sự tăng trưởng và nâng cao năng lực cạnh tranh của doanh nghiệp. Và để xây dựng được điều này, việc áp dụng công nghệ theo dõi vị trí thời gian thực (RTLS) là cần thiết.',
  keywords:
    'Smart logistics, trung tâm logistics quy mô lớn, logistics quy mô lớn, quản lý kho hàng, quản lý logistics, smart logistics, trung tam logistics quy mo lon, logistics quy mo lon, quan ly kho hang, quan ly logistics.',
  ogSite: 'Smart Logistics Center: RTLS - Nhân tố thay đổi cuộc chơi',
  title: 'Smart Logistics Center: RTLS - Nhân tố thay đổi cuộc chơi',
  ogUrl: 'https://orbro.io/vi/blog/logistics',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AKsag4Nn92GBAhAnqBNHPYNQDpB-QpINtYBr8NP1whgOrOeiJ231ayd-ir1pFXYQyPNn6ORiGuT9r9NH8WMwpUVVIJuDIDCcxjED8rHcdEkrjVEabQroYsK8zKZBFb5y7MqX52j_Hsy7L5ePRwrLj1l5AgzzhwwwRDy0SSWbba5oN-o3v4VK9ulJDIn-AlRzUvK-2_ExWeqxWtqjdDVGF780Q1Fyw9IIdObKFPnjkNtFBBQtMXHmKC4K3NY-PU75is1fvZGtz95FAVwQW8NW-iuI9-V6GgxYKoSSaE0VpltJTXpVeUwTA-55-8pGVLMV1jPeO1vGqDiJJsSQfFQE7xxXm6-UZvVDalr763kudRcjaH6dWNitPT2w4_qxEV3EivvyxvKRAKilLymJIzk-KgoGkU4hhuVrqpelXsjpiyAVrTRehdny-SFdJeuDk7TnnLXSFTf8rG1zgj4OOJcXrXqDmjNcKnSmD3gyrnY_7gEkAde2Vn2Wnm9hQewDJ1YDCx926J3unTLJApvy7uGKDbgGwZY0jfHbj3_EaB-5t5TBucsd2CukDZvZ27jfvLUUe1Wrr0-U21oag_JP6AeJNO-Thzp8fvPd1rmpOiKsPwlCOEdTn-aVu9hoAWByLe-OAQ_weFNJB2jqIOrRDEiEdsF2Ux_D4H4UY0gjcEi6EuIl2SaJ7GQEfGt0uQ1BSYXOm6_Ljse4BNu1hSdj9Iqtg7MstD1cwgxIVmXk20C1GudLlOL14w-EOHYMhOg-CdEf_6i7jOS4F-HZVe98fBNM8s4m5pjIUFngbQ9Ig158BQ2ZwJB2t05BgqvZDYMA33z6z0iOiRAnmT6J9sYM2yx4itS08KP1CgjFduRqis5fJcg9eFZuZJf5Hfd-vWgWD6fl5ssh6du1AEaEBLfbbmiNhDihCB-M0jHlLuDCL-wWrFKTCo3ylcA89Xivl7Hca0rY3s6JW_VfSwboGpYKJnMKpZqynEuHGMXoYXQ3jFpIQPj2xOElK8OLo1o3oQdjWPzTb4vUKBHiBzM6qkfsUZAL4b-zqcL2KxE1jgAyweOBCYpp3CdQ7LCgDO6I5VfS8lzcNBPnPq8_5OkN_r6xGcemqmtbzIIFQonHkEIYSOl0km6axb9eXkmCacj_0lr5oyGA8xGjLFN85rAsznmLomsfvDmvk8qx1fT8OQGW0Fsqgeeoujl6HOsXsGEVr-4dP1EupFbf4WR-v8GPCBN-c9FSQ7472yBB8ES-QlDo-xEP0xB8bn0ogShH5PCnzG3aQ1Y8fpAK_nzqUPpkZDW0HEUKQw6shyWu9MqPLKD1IbYuzWo_9Vba83qhFFvye5IxqyGiZr2SG2wZpmu1kWNjSG89Br3ZMTKQ2XSVpURse0EKs4abuIUAjtf7O1t3PVWF1Hm8R2Pllgb36whs0ZsXEgvM3gAghdJ_T8ydCqOD76BitUXjI_oV_2cn7KlbYyMsT90CHLr6NrT0ZW3B0s-hDXnGSiwvDM7ZCywF8XguZFj2X3konPXb1o1blj-A6LDR-ROdDTdsc9jBotrseWFE7qTdeVNs92ZxvaiWGvziDNdVARHQAwQIY5krEfq8B6DpkghJNg=w2194-h1199',
  ogType: 'website',
  date: '2023-09-04',
  tag1: '#Smartlogistics',
  tag2: '#Trungtamlogisticsquymolon',
  tag3: '#Logisticsquymolon',
  tag4: '#Quanlykhohang',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Smart Logistics Center (Trung tâm Logistics Thông minh) có sự khác biệt lớn so với ngành logistics truyền thống về mặt hiệu quả và năng suất. Do khả năng quản lý hiệu quả tài sản, hàng tồn kho và nhân lực để tối đa hóa năng suất và giảm thiểu sai sót, việc xây dựng Smart Logistics Center đã trở thành yếu tố thiết yếu cho sự tăng trưởng và nâng cao năng lực cạnh tranh của doanh nghiệp. Và để xây dựng được điều này, việc áp dụng công nghệ theo dõi vị trí thời gian thực (RTLS) là cần thiết.\n\n Chúng ta hãy cùng tìm hiểu xem những điều gì sẽ trở nên khả thi nếu áp dụng giải pháp theo dõi vị trí thời gian thực tại Smart Logistics Center.',
      dot: '',
    },
    {
      head: '1. Tối ưu hóa quản lý và theo dõi tài sản',
      subHead: '',
      desc: 'Công nghệ RTLS được sử dụng để theo dõi mọi tài sản và thiết bị trong trung tâm logistics theo thời gian thực. Qua đó, người quản lý trung tâm logistics có thể nắm bắt chính xác vị trí và tình trạng của tài sản. Ví dụ, bằng cách xác định vị trí của xe kéo container (cargo trailer) hoặc xe nâng (forklift) theo thời gian thực, có thể tối ưu hóa tỷ lệ sử dụng tài sản và lên kế hoạch bảo trì hiệu quả khi cần thiết. Nhờ vậy, chi phí quản lý tài sản giảm xuống và tuổi thọ của tài sản được kéo dài.',
      dot: '',
    },
    {
      head: '2. Nâng cao độ chính xác trong quản lý hàng tồn kho',
      subHead: '',
      desc: 'Thông qua RTLS, có thể xác định vị trí của sản phẩm và hàng tồn kho theo thời gian thực. Điều này mang lại một cuộc cách mạng trong quản lý hàng tồn kho. Việc xác định chính xác sản phẩm nào đang ở vị trí nào trong trung tâm logistics giúp giảm thiểu tổn thất hàng tồn kho và tối ưu hóa vòng quay tồn kho. Nhờ đó, đạt được việc cắt giảm chi phí và nâng cao hiệu quả.',
      dot: '',
    },
    {
      head: '3. Phân tích dữ liệu thời gian thực',
      subHead: '',
      desc: 'RTLS tạo ra dữ liệu thời gian thực, và bằng cách phân tích dữ liệu này, có thể theo dõi và tối ưu hóa hoạt động của trung tâm logistics theo thời gian thực. Nếu xảy ra tình trạng tắc nghẽn ở bất kỳ quy trình nào trong trung tâm logistics, người quản lý có thể ngay lập tức thực hiện các biện pháp để giải quyết vấn đề. Điều này cũng tác động tích cực đến dịch vụ khách hàng.',
      dot: '',
    },
    {
      head: '4. Tối ưu hóa nguồn nhân lực',
      subHead: '',
      desc: 'RTLS cũng hỗ trợ trong việc quản lý nguồn nhân lực. Bằng cách theo dõi sự di chuyển và thời gian làm việc của người lao động, có thể nâng cao hiệu quả làm việc của họ và tối ưu hóa lịch trình công việc. Việc sử dụng RTLS để bố trí nhân sự hiệu quả và điều phối công việc trong trung tâm logistics giúp cắt giảm chi phí nhân công và nâng cao năng suất.',
      dot: '',
    },
    {
      head: '5. Nâng cao dịch vụ Khách hàng',
      subHead: '',
      desc: 'RTLS đóng vai trò quan trọng trong cả quy trình xử lý đơn hàng và giao nhận. Bằng cách xác định vị trí sản phẩm theo thời gian thực, có thể cung cấp cho khách hàng thời gian dự kiến nhận hàng chính xác, từ đó nâng cao chất lượng dịch vụ khách hàng. Khách hàng sẽ hài lòng hơn vì họ có thể nhận được thông tin về thời điểm sản phẩm sẽ đến.',
      dot: '',
    },
    {
      head: '6. Tăng cường an ninh và an toàn',
      subHead: '',
      desc: 'RTLS giúp tăng cường an toàn và an ninh cho trung tâm logistics. Việc xác định chính xác vị trí của thiết bị và tài sản giúp ngăn chặn xâm nhập trái phép hoặc trộm cắp hàng tồn kho, đồng thời đảm bảo an toàn thông qua việc kiểm tra và bảo trì thiết bị định kỳ.',
      dot: '',
    },
    {
      head: '7. Tăng cường tính thân thiện với môi trường',
      subHead: '',
      desc: 'Smart Logistics Center có thể cải thiện hiệu quả sử dụng năng lượng và tài nguyên. RTLS có thể hỗ trợ tìm ra các phương pháp để tối ưu hóa việc sử dụng tài nguyên và giảm tiêu thụ năng lượng. Ví dụ, có thể tự động điều chỉnh hệ thống chiếu sáng và máy móc trong trung tâm logistics để tối ưu hóa việc tiêu thụ năng lượng.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
